import { render, staticRenderFns } from "./SocialSummaryControls.vue?vue&type=template&id=4d0f1c32&"
import script from "./SocialSummaryControls.vue?vue&type=script&lang=js&"
export * from "./SocialSummaryControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports